export default {
  namespaced: true,
  state: {
    sidebarOpened: true
  },
  mutations: {
    TOGGLE_SIDEBAR: state => { state.sidebarOpened = !state.sidebarOpened }
  },
  actions: {
    toggleSidebar({ commit }) { commit('TOGGLE_SIDEBAR') }
  }
}
